import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../../store/api/rx-factory'
import * as Enpoints from '../../../../../store/api/endpoints'

export const actions = {
	//contact us
	[Const.RUN_GET_CONTACT_US]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_CONTACT_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CONTACT_US, result.res_data)
			}else{
				commit(Const.SET_CONTACT_US, [])
			}
		}) 
  	},
	[Const.RUN_CONTACT_US]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CONTACT_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.getInfo()
				_messageDisplayFunction(credentials.localParams.parameter,'Contact details updated successfully')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_BONUS_DISABLE]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_BONUS_DISABLE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.globalParams.status == 1){
					_messageDisplayFunction(credentials.localParams.parameter,'Bonus Disabled successfully','success')
				}else{ _messageDisplayFunction(credentials.localParams.parameter,'Bonus Enabled successfully','success') }
				credentials.localParams.parameter.detailBonus()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	//disable
	[Const.RUN_DISABLE2FA]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DISABLE2FA, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.disable2Fa = false
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'disable 2FA successfully','success')
			}else{
				credentials.localParams.parameter.disable2Fa = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//===============================request otp=================================================
	[Const.RUN_REQUEST_OTP]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_REQUEST_OTP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.submitted = false
				credentials.localParams.parameter.email = ''
				credentials.localParams.parameter.otpScreen = true
				credentials.localParams.parameter.trans_id = result.res_data.trans_id
				credentials.localParams.parameter.lead_id = result.res_data.lead_id
				_messageDisplayFunction(credentials.localParams.parameter,'otp has been sent in your given email id','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_VERIFY_OTP]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_VERIFY_OTP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.lead_id){
					credentials.localParams.parameter.$router.replace({name: 'client.clientView', query: {'id':result.res_data.lead_id}})
				}else{
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				}
				
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
//==============================docuemnt link================================================
	[Const.RUN_DOCUMENT_LINK_API]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DOCUMENT_LINK_API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				window.open(result.res_data,'_blank');
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
//====================================admin=================================================
	[Const.RUN_GET_ADMIN_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_ADMIN_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.pgeName){ 
					credentials.localParams.parameter.searchResult = result.res_data
				}else{
					commit(Const.SET_ADMIN_LIST, result.res_data)
				}
			}else{
				if(credentials.localParams.pgeName){
					credentials.localParams.parameter.searchResult = {}
				}else{
					commit(Const.SET_ADMIN_LIST, [])
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_ADMIN_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ADMIN_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_ADMIN_DETAIL, result.res_data[0])
			}else{
				commit(Const.SET_ADMIN_DETAIL, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_ADD_ADMIN]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_ADMIN, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create admin successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_UPDATE_ADMIN_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_ADMIN_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			credentials.localParams.parameter.showEditConfirm = '0'
			if(!error){
				console.log(credentials.localParams.type)
				if(credentials.localParams.type == 'EMAIL'){
					credentials.localParams.parameter.email = ''
					credentials.localParams.parameter.emailEdit = false
				}else if(credentials.localParams.type == 'ROLE'){
					credentials.localParams.parameter.role = []
					credentials.localParams.parameter.roleEdit = false
				}else if(credentials.localParams.type == 'ACCURACY'){
					credentials.localParams.parameter.accuracy = ''
					credentials.localParams.parameter.accuracyEdit = false
				}else if(credentials.localParams.type == 'PASSWORD'){
					credentials.localParams.parameter.password = ''
					credentials.localParams.parameter.passwordEdit = false
				}else if(credentials.localParams.type == 'OTHERS'){
					credentials.localParams.parameter.namef = ''
					credentials.localParams.parameter.namel = '' 
					credentials.localParams.parameter.username = ''
					credentials.localParams.parameter.dob = ''
					credentials.localParams.parameter.agent_id = ''
					credentials.localParams.parameter.mobile_no = ''
					credentials.localParams.parameter.add_no = ''
					credentials.localParams.parameter.city = ''
					credentials.localParams.parameter.zip = ''
					credentials.localParams.parameter.country = ''
					credentials.localParams.parameter.note = ''
					credentials.localParams.parameter.nameEdit = false
				}else if(credentials.localParams.type == 'SHIFT_TIME'){
					credentials.localParams.parameter.shifttime_in = ''
					credentials.localParams.parameter.shifttime_out = ''
					credentials.localParams.parameter.shiftEdit = false
				}else if(credentials.localParams.type == 'DOCUMENT'){
					credentials.localParams.parameter.document = ''
					credentials.localParams.parameter.docEdit = false
				}
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
//===================================client admin===========================================
	[Const.RUN_VERIFY_ADMIN]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_VERIFY_ADMIN,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let data = (credentials.globalParams.verify == 1)? 'verify' : 'unverify'
				credentials.localParams.parameter.$parent.detail()
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,data + ' account successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_DISABLE_ADMIN]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_DISABLE_ADMIN,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let data = (credentials.globalParams.status == 1)? 'Enable' : 'Disable'
				credentials.localParams.parameter.$parent.detail()
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,data + ' account successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_VERIFY_CLIENT]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_VERIFY_CLIENT,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let data = (credentials.globalParams.verify == 1)? 'verify' : 'unverify'
				credentials.localParams.parameter.$parent.detail()
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,data + ' account successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_DISABLE_CLIENT]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_DISABLE_CLIENT,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let data = (credentials.globalParams.status == 1)? 'Enable' : 'Disable'
				credentials.localParams.parameter.$parent.detail()
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,data + ' account successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},

	[Const.RUN_GET_COUNTRIES_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COUNTRIES_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COUNTRIES_LIST, result.res_data)
			}else{
				commit(Const.SET_COUNTRIES_LIST, [])
			}
		})
  	},
	[Const.RUN_GET_CITIES_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_CITIES_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CITIES_LIST, result.res_data)
			}else{
				commit(Const.SET_CITIES_LIST,[])
			}
		})
	},
//client
	[Const.RUN_CREATE_CLIENT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_CLIENT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'Client Created successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_USER_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_USER_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.page == 'search'){
					credentials.localParams.parameter.searchData = result.res_data
				}else{
					commit(Const.SET_USER_LIST, result.res_data)
				}
			}else{
				if(credentials.localParams.page == 'search'){
					credentials.localParams.parameter.searchData = []
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				}else{
					commit(Const.SET_USER_LIST, [])
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				}
				
			}
		}) 
  	},
	[Const.RUN_UPDATE_CLIENT_DETAIL]({commit, state,getters,dispatch}, credentials){	
	_executeApi(Enpoints.EP_UPDATE_CLIENT_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
		credentials.localParams.parameter.showEditConfirm = '0'
		if(!error){
			if(credentials.localParams.type == 'ADDRESS'){
				credentials.localParams.parameter.addressEdit = false
				credentials.localParams.parameter.address = ''
				credentials.localParams.parameter.post_code = ''
				credentials.localParams.parameter.city = ''
				credentials.localParams.parameter.country = ''
			}else if(credentials.localParams.type == 'BANK'){
				credentials.localParams.parameter.bankEdit = false
				credentials.localParams.parameter.company_name  = ''
				credentials.localParams.parameter.benificiary_name   = ''
				credentials.localParams.parameter.bank_acc_no  = ''
				credentials.localParams.parameter.bank_name  = ''
				credentials.localParams.parameter.iban_number  = ''
				credentials.localParams.parameter.bic  = ''
				credentials.localParams.parameter.account_type  = ''
				credentials.localParams.parameter.swift_code  = ''
				credentials.localParams.parameter.paypal_id  = ''
				credentials.localParams.parameter.skrill_id  = ''
				credentials.localParams.parameter.neteller_id  = ''
			}else if(credentials.localParams.type == 'EMAIL'){
				credentials.localParams.parameter.emailEdit = false
				credentials.localParams.parameter.email = ''
			}else if(credentials.localParams.type == 'PASSWORD'){
				credentials.localParams.parameter.passEdit = false
				credentials.localParams.parameter.password = ''
			}else if(credentials.localParams.type == 'OTHER_INFO'){
				credentials.localParams.parameter.clientEdit = false
				credentials.localParams.parameter.namef = ''
				credentials.localParams.parameter.namel = ''
				credentials.localParams.parameter.gender = ''
				credentials.localParams.parameter.dob = ''
				credentials.localParams.parameter.secondary_number = ''
			}else if(credentials.localParams.type == 'DOCUMENT'){
				credentials.localParams.parameter.docEdit = false
				credentials.localParams.parameter.document = ''
			}  
			credentials.localParams.parameter.detail()
			_messageDisplayFunction(credentials.localParams.parameter,'update successfully','success')
		}else{
			_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
		}
	}) 
	},
	[Const.RUN_GET_USER_VIEW]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_USER_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_USER_VIEW, result.res_data[0])
				if(credentials.localParams.page && credentials.localParams.page == 'createPdf'){
					credentials.localParams.parameter.$router.push({ path: '/clientpdf', query:{ "id" : credentials.globalParams.user_id } })
				}else{
					credentials.localParams.parameter.$router.push({ path: '/view', query: { "id" : credentials.globalParams.user_id } })
				}
				
			}else{
				commit(Const.SET_USER_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	//reset password
	[Const.RUN_RESET_PASSWORD]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_RESET_PASSWORD, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.resetPasswordConfirm = false
				_messageDisplayFunction(credentials.localParams.parameter,'password reset successfully','success')
			}else{
				credentials.localParams.parameter.resetPasswordConfirm = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
// =================logs================
	[Const.RUN_GET_LOGS_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_LOGS_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOGS_LIST, result.res_data)
			}else{
				commit(Const.SET_LOGS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
//====================================bonus=============================================
	[Const.RUN_GET_BONUS_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_BONUS_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_BONUS_LIST, result.res_data)
			}else{
				commit(Const.SET_BONUS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_BONUS_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_BONUS_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_BONUS_VIEW, result.res_data[0])
				if(credentials.localParams.page == 'edit'){
					credentials.localParams.parameter.insertData()
				}
				//credentials.localParams.parameter.$router.push({ path: '/bonus-view', query: { "id" : credentials.globalParams.user_id } })
			}else{
				commit(Const.SET_BONUS_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_ADD_BONUS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_ADD_BONUS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'Bonus Add successfully','success')
				credentials.localParams.parameter.reset()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_BONUS_UPDATE]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_BONUS_UPDATE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.backToBonusView()
				_messageDisplayFunction(credentials.localParams.parameter,'Bonus Update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
//====================================deposit================================================
	[Const.RUN_CREATE_DEPOSIT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_DEPOSIT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'create deposit successfully','success')
				credentials.localParams.parameter.reset()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_DEPOSIT_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_DEPOSIT_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_DEPOSIT_LIST, result.res_data)
			}else{
				commit(Const.SET_DEPOSIT_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_DEPOSIT_TRANSACTION]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_DEPOSIT_TRANSACTION, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_DEPOSIT_TRANSACTION, result.res_data)
			}else{
				commit(Const.SET_DEPOSIT_TRANSACTION, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_DEPOSIT_VIEW]({commit, state,getters,dispatch}, credentials){		
		_executeApi(Enpoints.EP_GET_DEPOSIT_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_DEPOSIT_VIEW, result.res_data[0])
				if(credentials.localParams.page == 'edit'){
					credentials.localParams.parameter.insertData()
				}
				//credentials.localParams.parameter.$router.push({path: '/deposit-view',query: { "id" : credentials.globalParams.user_id } })
			}else{
				commit(Const.SET_DEPOSIT_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_EDIT_DEPOSIT_DETAILS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_EDIT_DEPOSIT_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'update deposit detail successfully','success')
				credentials.localParams.parameter.backToDepositView()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},

//====================================wallet================================================
	[Const.RUN_GET_WALLET_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_DEPOSIT_TRANSACTION, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_WALLET_LIST, result.res_data)
			}else{
				commit(Const.SET_WALLET_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
//====================================trading================================================
	[Const.RUN_GET_TRADING_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_TRADING_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TRADING_LIST, result.res_data)
			}else{
				commit(Const.SET_TRADING_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_TRADING_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TRADING_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TRADING_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({ path: '/trading-view', query: { "id" : credentials.globalParams.id } })
			}else{
				commit(Const.SET_TRADING_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_EDIT_TRADING_DETAILS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_EDIT_TRADING_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//credentials.localParams.parameter.edit_detail = false
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_DISABLE_TRADING_ACCOUNT]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DISABLE_TRADING_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//credentials.localParams.parameter.edit_detail = false
				if(credentials.globalParams.delete_trade_acc == 1){
					_messageDisplayFunction(credentials.localParams.parameter,'Disabled account successfully','success')
				}else{ _messageDisplayFunction(credentials.localParams.parameter,'Enabled account successfully','success') }
				credentials.localParams.parameter.detail()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_CHANGE_TRADING_ACCOUNT_STATUS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CHANGE_TRADING_ACCOUNT_STATUS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_CHANGE_LEVERAGE]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CHANGE_LEVERAGE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.leverageEdit = false
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'change leverage successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
//====================================ticket=================================================
	[Const.RUN_CLOSE_TICKET]({commit, state,getters,dispatch}, credentials){
		let API;
		if(parseInt(credentials.localParams.reason) == 97){
			API = Enpoints.EP_EDIT_WITHDRAWAL_DETAILS
			credentials.globalParams.status = '0'
		}else{
			API = Enpoints.EP_CLOSE_TICKET
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				if(credentials.localParams.module == 'reject'){
					credentials.localParams.parameter.reset()
					_messageDisplayFunction(credentials.localParams.parameter,'reject ticket successfully','success')
				}else{
					_messageDisplayFunction(credentials.localParams.parameter,'close ticket successfully','success')
				}
			}else{
				if(credentials.localParams.module == 'reject'){
					credentials.localParams.parameter.reset()
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_TICKET_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TICKET_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TICKET_VIEW, result.res_data)
			}else{
				commit(Const.SET_TICKET_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_TICKET_REPLY]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_REPLY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'message sent successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_ADD_TICKET]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_TICKET, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create ticket successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_TICKET_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TICKET_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TICKET_LIST, result.res_data)
			}else{
				commit(Const.SET_TICKET_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
//====================================withdrawal=============================================
	[Const.RUN_ADD_WITHDRAWAL]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_WITHDRAWAL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create withdrawal successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_ACCOUNT_DETAIL]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_ACCOUNT_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.balance = result.res_data.balance
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_WITHDRAWAL_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_WITHDRAWAL_LIST, result.res_data)
			}else{
				commit(Const.SET_WITHDRAWAL_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_WITHDRAWAL_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_WITHDRAWAL_VIEW, result.res_data[0])
				if(credentials.localParams.page == 'edit'){
					credentials.localParams.parameter.insertData()
				}
				//credentials.localParams.parameter.$router.push({ path: '/withdrawal-view', query: { "id" : credentials.globalParams.user_id } })
			}else{
				commit(Const.SET_WITHDRAWAL_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_EDIT_WITHDRAWAL_DETAILS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_EDIT_WITHDRAWAL_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit,(error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'Withdrawal detail update successfully','success')
				credentials.localParams.parameter.edit_detail = false
				credentials.localParams.parameter.backToWithdrawalView()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},



	// never found its use
//====================================coupon================================================
	[Const.RUN_CREATE_COUPON]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_CREATE_COUPON,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'coupon create successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_UNSUBSCRIBE]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_UNSUBSCRIBE,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'service unsubscribed successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_COUPON_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COUPON_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COUPON_LIST, result.res_data)
			}else{
				commit(Const.SET_COUPON_LIST,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_PLAN_COUPON_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_PLAN_COUPON_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.plan_coupon_list_array = result.res_data
			}else{
				credentials.localParams.parameter.plan_coupon_list_array = ''
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_SUB_EXSIST_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SUB_EXSIST_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_SUB_EXSIST_LIST, result.res_data)
			}else{
				commit(Const.SET_SUB_EXSIST_LIST,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_SUB_OPER]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SUB_OPER,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'An OTP has been sent on the registered email of client','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_SUB_PLAN_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SUB_PLAN_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_SUB_PLAN_LIST, result.res_data)
			}else{
				commit(Const.SET_SUB_PLAN_LIST,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_SUB_PLAN_DETAIL]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SUB_PLAN_DETAIL,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.subscri_detail = result.res_data
				commit(Const.SET_SUB_PLAN_DETAIL, result.res_data)
			}else{
				commit(Const.SET_SUB_PLAN_DETAIL,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
//====================================reporting=============================================
	[Const.RUN_CREATE_REPORT]({commit, state, dispatch,getters}, credentials){
		let API = ''
		if(credentials.localParams.report_status == '0'){
			API = Enpoints.EP_CREATE_COLLATERAL_PORTFOLIO
		}else if(credentials.localParams.report_status == '1'){
			API = Enpoints.EP_CREATE_EMIR_INSTRUMENTS
		}else if(credentials.localParams.report_status == '2'){
			API = Enpoints.EP_CREATE_MIFIR_INSTRUMENTS
		}else if(credentials.localParams.report_status == '3'){
			API = Enpoints.EP_CREATE_REPORTING_MEMBER
		}
		_executeApi(API,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create report successfully','error')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_REPORTING_LIST]({commit, state, dispatch,getters}, credentials){
		let API = ''
		if(credentials.localParams.report_status == '0'){
			API = Enpoints.EP_GET_COLLATERAL_PORTFOLIO_LIST
		}else if(credentials.localParams.report_status == '1'){
			API = Enpoints.EP_GET_EMIR_INSTRUMENTS_LIST
		}else if(credentials.localParams.report_status == '2'){
			API = Enpoints.EP_GET_MIFIR_INSTRUMENTS_LIST
		}else if(credentials.localParams.report_status == '3'){
			API = Enpoints.EP_GET_REPORTING_MEMBER_LIST
		}
		_executeApi(API,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let cutColArray = []
				if(credentials.localParams.report_status == '1' && result.res_data.totalRecords > 0){
					for(let i=0 ; i<=result.res_data.records.length -1 ; i++){
						cutColArray[result.res_data.records[i].id] = {
							
							'Product_Classification':  result.res_data.records[i].Product_Classification,
							'Product_Identification_Type':  result.res_data.records[i].Product_Identification_Type,
							'Product_Identification':  result.res_data.records[i].Product_Identification,
							'Underlying_Type':  result.res_data.records[i].Underlying_Type,
							'Underlying_Id':  result.res_data.records[i].Underlying_Id,
							'Base_Currency':  result.res_data.records[i].Base_Currency,
							'Quote_Currency':  result.res_data.records[i].Quote_Currency,
							'Venue':  result.res_data.records[i].Venue,
							'Compressed_Trade':  result.res_data.records[i].Compressed_Trade,
							'Price_Notation':  result.res_data.records[i].Price_Notation,
							'Maturity_Date':  result.res_data.records[i].Maturity_Date,
							'Delivery_Type':  result.res_data.records[i].Delivery_Type,
							'Clearing':  result.res_data.records[i].Clearing,
							'Commodity_Base':  result.res_data.records[i].Commodity_Base,
							'Commodity_Details':  result.res_data.records[i].Commodity_Details,
							'Strike_Price_Notation':  result.res_data.records[i].Strike_Price_Notation,
							'Seniority':  result.res_data.records[i].Seniority,
							'Payment_Frequency':  result.res_data.records[i].Payment_Frequency,
							'Day_Count':  result.res_data.records[i].Day_Count,
							'Series':  result.res_data.records[i].Series,
							'Version':  result.res_data.records[i].Version,
							'Index_Factor':  result.res_data.records[i].Index_Factor,
							'Tranche':  result.res_data.records[i].Tranche,
							'Attachment_Point':  result.res_data.records[i].Attachment_Point,
							'Detachment_Point':  result.res_data.records[i].Detachment_Point,
							'Reference_Entity':  result.res_data.records[i].Reference_Entity,
							'Valuation_Market':  result.res_data.records[i].Valuation_Market,
							'Valuation_Symbol':  result.res_data.records[i].Valuation_Symbol
						}
						delete result.res_data.records[i]['Product_Classification']
						delete result.res_data.records[i]['Product_Identification_Type']
						delete result.res_data.records[i]['Product_Identification']
						delete result.res_data.records[i]['Underlying_Type']
						delete result.res_data.records[i]['Underlying_Id']
						delete result.res_data.records[i]['Base_Currency']
						delete result.res_data.records[i]['Quote_Currency']
						delete result.res_data.records[i]['Venue']
						delete result.res_data.records[i]['Compressed_Trade']
						delete result.res_data.records[i]['Price_Notation']
						delete result.res_data.records[i]['Maturity_Date']
						delete result.res_data.records[i]['Delivery_Type']
						delete result.res_data.records[i]['Clearing']
						delete result.res_data.records[i]['Commodity_Base']
						delete result.res_data.records[i]['Commodity_Details']
						delete result.res_data.records[i]['Strike_Price_Notation']
						delete result.res_data.records[i]['Seniority']
						delete result.res_data.records[i]['Payment_Frequency']
						delete result.res_data.records[i]['Day_Count']
						delete result.res_data.records[i]['Series']
						delete result.res_data.records[i]['Version']
						delete result.res_data.records[i]['Index_Factor']
						delete result.res_data.records[i]['Tranche']
						delete result.res_data.records[i]['Attachment_Point']
						delete result.res_data.records[i]['Detachment_Point']
						delete result.res_data.records[i]['Reference_Entity']
						delete result.res_data.records[i]['Valuation_Market']
						delete result.res_data.records[i]['Valuation_Symbol'] 
						if(i == result.res_data.records.length -1){
							credentials.localParams.parameter.column_array = cutColArray
							// console.log('cutColArray=======',cutColArray)
							commit(Const.SET_REPORTING_LIST, result.res_data)
						}
					}
				}else if(credentials.localParams.report_status == '2' && result.res_data.totalRecords > 0){
					for(let i=0 ; i<=result.res_data.records.length -1 ; i++){
						cutColArray[result.res_data.records[i].id] = {
							'Notional_Currency_2':  result.res_data.records[i].Notional_Currency_2 ,
							'Instrument_Notional_Currency':  result.res_data.records[i].Instrument_Notional_Currency ,
							'Underlying_Index_Name':  result.res_data.records[i].Underlying_Index_Name ,
							'Underlying_Index_Term':  result.res_data.records[i].Underlying_Index_Term ,
							'Price_Multiplier':  result.res_data.records[i].Price_Multiplier ,
							'Quantity_Type':  result.res_data.records[i].Quantity_Type ,
							'Price_Notation_Type':  result.res_data.records[i].Price_Notation_Type ,
							'Underlying_Id':  result.res_data.records[i].Underlying_Id ,
							'Venue':  result.res_data.records[i].Venue ,
							'Maturity_Date':  result.res_data.records[i].Maturity_Date ,
							'Expiry_Date':  result.res_data.records[i].Expiry_Date ,
							'Delivery_Type':  result.res_data.records[i].Delivery_Type ,
							'Strike_Price_Notation_Type':  result.res_data.records[i].Strike_Price_Notation_Type
						}
						delete result.res_data.records[i]['Notional_Currency_2']
						delete result.res_data.records[i]['Instrument_Notional_Currency']
						delete result.res_data.records[i]['Underlying_Index_Name']
						delete result.res_data.records[i]['Underlying_Index_Term']
						delete result.res_data.records[i]['Price_Multiplier']
						delete result.res_data.records[i]['Quantity_Type']
						delete result.res_data.records[i]['Price_Notation_Type']
						delete result.res_data.records[i]['Underlying_Id']
						delete result.res_data.records[i]['Venue']
						delete result.res_data.records[i]['Maturity_Date']
						delete result.res_data.records[i]['Expiry_Date']
						delete result.res_data.records[i]['Delivery_Type']
						delete result.res_data.records[i]['Strike_Price_Notation_Type']
						
						if(i == result.res_data.records.length -1){
							credentials.localParams.parameter.mifirColumn_array = cutColArray
							commit(Const.SET_REPORTING_LIST, result.res_data)
						}
					}
				}else{
					commit(Const.SET_REPORTING_LIST, result.res_data)
				}
			}else{
				commit(Const.SET_REPORTING_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
//====================================email=================================================
	[Const.RUN_EMAIL_SETTING_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_EMAIL_SETTING_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_EMAIL_SETTING_LIST, result.res_data)
			}else{
				commit(Const.SET_EMAIL_SETTING_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_ADD_EMAIL_SETTING]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_EMAIL_SETTING, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create email successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//=====================================faq==================================================
	[Const.RUN_CREATE_CATEGORY]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_CATEGORY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.module == 'edit'){
					credentials.localParams.parameter.$router.push({ path: '/category-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'edit category successfully','success')
				}else{
					credentials.localParams.parameter.reset()
					_messageDisplayFunction(credentials.localParams.parameter,'create category successfully','success')
				}
			}else{
				if(credentials.localParams.module != 'edit'){
					credentials.localParams.parameter.reset()
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CREATE_ARTICLE]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_ARTICLE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.module == 'edit'){
					credentials.localParams.parameter.$router.push({ path: '/articles-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'edit article successfully','success')
				}else{
					credentials.localParams.parameter.reset()
					_messageDisplayFunction(credentials.localParams.parameter,'create article successfully','success')
				}
			}else{
				if(credentials.localParams.module != 'edit'){
					credentials.localParams.parameter.reset()
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ARTICLE_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ARTICLE_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_ARTICLE_LIST, result.res_data)
			}else{
				commit(Const.SET_ARTICLE_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_CAT_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_CAT_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CAT_LIST, result.res_data)
			}else{
				commit(Const.SET_CAT_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ARTICLE_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ARTICLE_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.art_name = result.res_data[0].articleName
				credentials.localParams.parameter.art_desc = result.res_data[0].description
				credentials.localParams.parameter.categoryId = result.res_data[0].categoryId
				credentials.localParams.parameter.category = result.res_data[0].catSlug
				credentials.localParams.parameter.status = result.res_data[0].status
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_CAT_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_CAT_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.cat_name = result.res_data[0].name
				credentials.localParams.parameter.cat_desc = result.res_data[0].description
				credentials.localParams.parameter.status = result.res_data[0].status
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================client=================================================
	[Const.RUN_WITHDRAWAL_METHODS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_WITHDRAWAL_METHODS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, result.res_data)
				let json ={} , count =0 ;
				for(var key in result.res_data){
					count++
					json[key] = {}
					let count1 = 0
					for(var innerkey in result.res_data[key]){
						count1++
						json[key][result.res_data[key][innerkey].id] = result.res_data[key][innerkey]
						if(count1 == Object.keys(result.res_data[key]).length){
							//console.log(json)
						}
					}
					if(count == Object.keys(result.res_data).length){
						commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE,json)
					}
				}
			}else{
				commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_USER_COUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_USER_COUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_USER_COUNT, result.res_data)
			}else{
				commit(Const.SET_USER_COUNT, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_LOGS_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_LOGS_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOGS_VIEW, result.res_data[0])
			}else{
				commit(Const.SET_LOGS_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_LOGS_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_LOGS_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let logDataJsonArray = [] 
				credentials.localParams.parameter.logsDetailTab = true
				if(result.res_data.details.length > 0){
					for (var threadkey = 0; threadkey < result.res_data.details.length; threadkey++) {
						logDataJsonArray.push(JSON.parse(result.res_data.details[threadkey]))
						if(result.res_data.details.length-1 == threadkey){
							credentials.localParams.parameter.logsDetail = logDataJsonArray
						}
					}
				}else{
					credentials.localParams.parameter.logsDetail = []
				}
			}else{
				credentials.localParams.parameter.logsDetail = []
				credentials.localParams.parameter.logsDetailTab = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},	
//verify account
  	[Const.RUN_VERIFY_ACCOUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_VERIFY_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.verifyAccount = false
				_messageDisplayFunction(credentials.localParams.parameter,'verify account successfully','success')
			}else{
				credentials.localParams.parameter.verifyAccount = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//notification
  	[Const.RUN_USER_NOTIFICATIONS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_USER_NOTIFICATIONS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//commit(Const.SET_USER_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({ path: '/view', query: { "id" : credentials.globalParams.user_id } })
			}else{}
		}) 
  	},
//internal note
  	[Const.RUN_ADD_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_INTERNAL_NOTES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.internalNotes = false
				credentials.localParams.parameter.internalNoteForm = false
				credentials.localParams.parameter.desc = ''
				dispatch(Const.RUN_GET_INTERNAL_NOTES,{'globalParams' : {'user_id' : credentials.globalParams.user_id} ,'localParams' : {'parameter' : credentials.localParams.parameter}});
				_messageDisplayFunction(credentials.localParams.parameter,'add internal note successfully','success')
			}else{
				credentials.localParams.parameter.internalNotes = false
				credentials.localParams.parameter.internalNoteForm = false
				credentials.localParams.parameter.desc = ''
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_INTERNAL_NOTES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_INTERNAL_NOTES, result.res_data)
			}else{
				commit(Const.SET_INTERNAL_NOTES, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//get risk metrix
	[Const.RUN_GET_RISK_METRIX]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_RISK_METRIX, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_RISK_METRIX, result.res_data)
			}else{
				commit(Const.SET_RISK_METRIX, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================ticket=================================================
	[Const.RUN_TICKET_TRANSFER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_TRANSFER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'ticket transfer successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_TICKET_REASON_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_REASON_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TICKET_REASON_LIST, result.res_data)
			}else{
				commit(Const.SET_TICKET_REASON_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_TICKET_APPROVE]({commit, state,getters,dispatch}, credentials){
  		let API;
  		if(parseInt(credentials.localParams.reason) == 91 || parseInt(credentials.localParams.reason) == 92 || parseInt(credentials.localParams.reason) == 94){
  			API = Enpoints.EP_TICKET_APPROVE_USER
  		}else if(parseInt(credentials.localParams.reason) == 97){
  			API = Enpoints.EP_EDIT_WITHDRAWAL_DETAILS
			credentials.globalParams.status = '1'
  		}else{
  			API = Enpoints.EP_TICKET_APPROVE
  		}	
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				_messageDisplayFunction(credentials.localParams.parameter,'ticket approve successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_TICKET_DOC_APPROVE_REJECT]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_DOC_APPROVE_REJECT, credentials,credentials.localParams.parameter.$parent,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$parent.ticketDetail()
				_messageDisplayFunction(credentials.localParams.parameter,'documents successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
//====================================deposit================================================
	[Const.RUN_GET_DEPOSIT_TRANSACTION_STATUS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_DEPOSIT_TRANSACTION_STATUS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.trans_hitory = result.res_data
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},	
//====================================withdrawal=============================================	  
  	[Const.CALL_USER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.CALL_USER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit,(error, result)=>{
			if(error){
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================trading================================================
	[Const.RUN_CREATE_TRADING_ACCOUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_TRADING_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create trading account successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},

	[Const.RUN_GET_NOTIFICATION_LISTING]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_NOTIFICATION_LISTING, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_NOTIFICATION_LISTING, result.res_data)
			}else{
				commit(Const.SET_NOTIFICATION_LISTING, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},

//====================================commission=============================================
	[Const.RUN_GET_COMMISSION_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_COMMISSION_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COMMISSION_LIST, result.res_data)
			}else{
				commit(Const.SET_COMMISSION_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_COMMISSION_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_COMMISSION_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COMMISSION_VIEW, result.res_data[0])
				if(credentials.localParams.page == 'edit'){
					credentials.localParams.parameter.setDataFunc()
				}
			}else{
				commit(Const.SET_COMMISSION_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_COMMISSION_UPDATE]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_COMMISSION_UPDATE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.backToCommissionView()
				_messageDisplayFunction(credentials.localParams.parameter,'commission Update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},

  	/*[Const.RUN_DELETE_TRADING_ACCOUNT]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DELETE_TRADING_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//credentials.localParams.parameter.edit_detail = false
			}
		}) 
  	},*/
}

//------------------------------------------------------Functions------------------------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  	let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
 	commit("SET_INFO", msg)
}
function _handleErrorResponse(e, commit) {
  	let response = {info: 'NOK', msg: 'Service not available'}
  	if (typeof e.response === 'undefined') {
    	try {
      		const statusCheck = e.toString().toLowerCase()
	      	if (statusCheck.indexOf('network') > -1) {
	        	response = {info: 'NOK', msg: 'Network Error'}
	      	}
    	} catch (e) {}
  	} else {
    	response = e.response.data
	}
	_cleanUp(commit, response, response.status)
	if(typeof e.response !== 'undefined'){
		if(e.response.status == 401){
 			let data = {}
			let options = {}
			options.forward = true
	 		_handleLogout(data, commit, options)
	 	}
	}
}
function _handleLogout (data, commit, options) {
	let user = {}
	const state = []
	window.sessionStorage.setItem('user_info', "")
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		window.location.replace("/")
	}
}
function _executeApi (apiLink, credentials,getLoaderParams,getToken,commit, callback) {
	try{
		let response_array = [];
		if(credentials.localParams.module == 'ticket-reply'){ credentials.globalParams = credentials.globalParams.form }
		if(credentials.localParams.module == 'trading-changestatus'){ credentials.globalParams = credentials.globalParams.form }
		
		getLoaderParams.pageLoader = true
		RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams,getToken).map(response => response.data).subscribe(data => 
		{	
			getLoaderParams.pageLoader = false
			if ('info' in data){
				if (data.info === 'OK') {
					response_array.res_data = data.data
					callback(false, response_array)
				}
				else{
					response_array.res_data = data.msg
					callback(true, response_array)
				}
			}
		},
		e => {	_handleErrorResponse(e, commit)	}) 
	}catch(ex){	_handleErrorResponse(ex, commit) }
}
function _messageDisplayFunction(getParameter,getMessage,msgType){
	getParameter.$notify({
		group: 'foo',
		type : msgType,
		text: getMessage,
		duration: 4000,
		closeOnClick : true
	});
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/actions.js